<template>
  <div class="w-50 m-auto mb-3 px-3">
    <input 
      class="form-control me-2" 
      type="search" 
      placeholder="Escriba el nombre de un pais" 
      v-model="filter"
      @keyup="filtrarNombre"
    >
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { useStore } from 'vuex'

export default {
  setup() {
    const filter = ref('')
    const store = useStore()

    const filtrarNombre = () => {
      store.dispatch('filterByName', filter.value)
    }

    return { filter, filtrarNombre }
  },
}
</script>